<template>
  <div class="order-complete">
    <div class="container page">
      <form>
        <fieldset :disabled="inProgress">
          <legend>
            <h1>訂單</h1>
            <p>{{slug}}</p>
          </legend>
          <table class="table">
            <thead>
              <tr>
                <th class="text-left">餐點名稱</th>
                <th>價格</th>
                <th>數量</th>
                <th>小計</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(meal, index) in order.orderMeals" :key="index">
                <td class="text-left">{{meal.name}}</td>
                <td>{{meal.price}}</td>
                <td>{{meal.quantity}}</td>
                <td>{{meal.quantity*meal.price}}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th class="text-left">總額:</th>
                <td></td>
                <td></td>
                <td>{{order.amount}}</td>
              </tr>
              <tr>
                <th class="text-left">電話:</th>
                <td></td>
                <td></td>
                <td>{{order.phone}}</td>
              </tr>
            </tfoot>
          </table>
          <hr />
          <table class="float-right">
            <tr>
              <th class="text-left">狀態:</th>
              <td>
                備餐
                <input
                  class="align-middle"
                  type="checkbox"
                  :disabled="true"
                  v-model="order.status.ready"
                  :true-value="true"
                  :false-value="false"
                />
              </td>
              <td>
                遞送
                <input
                  :disabled="true"
                  class="align-middle"
                  type="checkbox"
                  v-model="order.status.sending"
                  :true-value="true"
                  :false-value="false"
                />
              </td>
              <td>
                付款
                <input
                  type="checkbox"
                  disabled
                  v-model="order.status.complete"
                  :true-value="true"
                  :false-value="false"
                />
              </td>
            </tr>
          </table>
        </fieldset>
        <button v-if="!order.status.complete"
          :disabled="inProgress"
          class="btn btn-secondary pull-xs-right"
          type="botton"
          @click="setComplete(order)"
        >收款</button>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
export default {
  name: "OrderComplete",
  async beforeRouteEnter(to, from, next) {
    await store.dispatch("fetchOrder", to.params.slug);
    return next();
  },
  async beforeRouteUpdate(to, from, next) {
    await store.dispatch("fetchOrder", to.params.slug);
    return next();
  },
  methods: {
    setComplete(order) {
      debugger;
      order.status.complete = true;
      this.$store.dispatch("orderSetStatus", order);
    }
  },
  data() {
    return {
      inProgress: false,
      errors: {}
    };
  },
  mounted() {},
  computed: {
    slug() {
      return this.$router.currentRoute.params.slug;
    },
    ...mapGetters(["order"])
  }
};
</script>
